<div
  class="item-container"
  [class.selected]="selected$ | async"
  [class.invisible-shape]="invisible$ | async"
>
  <div
    class="item-color-indicator"
    [style.background-color]="color$ | async"
  ></div>
  <mat-icon
    class="shape-type-icon"
    [svgIcon]="shape.type + '-shape-type'"
  ></mat-icon>
  <div class="item-info-container">
    <h3-annotation-label
      class="subtitle-03"
      [annotationType]="'shape'"
      [annotationId]="shape.index"
    ></h3-annotation-label>
    <div class="body-03 item-subtitle">
      <h3-shape-subpoint-count [shape]="shape"></h3-shape-subpoint-count>
      <span>-</span>
      <span>
        <span>#</span>
        <span class="shape-index">{{ shape.index }}</span>
      </span>
    </div>
  </div>
  <h3-shape-feedback-indicator
    [shapeIndex]="shape.index"
  ></h3-shape-feedback-indicator>
  <mat-icon
    *ngIf="isMissingRequiredTag$ | async"
    matTooltip="Missing shape attributes"
    class="material-symbols-outlined"
    color="warn"
    >error</mat-icon
  >
</div>
